import { EllipseIcon } from "@/shared/presentation/components/icons";
import { Button, HStack, VStack } from "@reverb-ui/react";
import { colors } from "@reverb-ui/tokens";
import React from "react";
export var Carousel = function (_a) {
    var iterableElement = _a.iterableElement, currentIndex = _a.currentIndex, setCurrentIndex = _a.setCurrentIndex;
    return (React.createElement(VStack, { mt: 10 },
        React.createElement(HStack, null, iterableElement.map(function (item, index) { return (React.createElement(Button, { key: index, variant: "ghost", size: "xs", onClick: function () { return setCurrentIndex(index); } },
            React.createElement(EllipseIcon, { dynamicColor: currentIndex === index ? colors.blue[400] : colors.gray[300] }))); }))));
};
